import { NgModule } from "@angular/core";

import { TrimWhitespaceInputValueDirective } from "./trim-whitespace-input-value.directive";

const DIRECTIVES = [TrimWhitespaceInputValueDirective];

@NgModule({
	imports: [],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class TrimWhitespaceInputValueModule {}
